var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTableView',{attrs:{"head":_vm.tableHead,"list-view":"lgAndUp"}},_vm._l((_vm.workTypeCategoryGrid),function(item){return _c('WorkTypeCategoryTableItem',{key:item.id,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }